import IEndOfProductionDateRepository from '../domain/IEndOfProductionDateRepository';
import EndOfProductionDateRepository from '../infrastructure/repositories/EndOfProductionDateRepository';

class DownloadCesedHistoricalCase {
  private readonly _endOfProductionDateRepository: IEndOfProductionDateRepository;

  constructor({ endOfProductionDateRepository }) {
    this._endOfProductionDateRepository = endOfProductionDateRepository;
  }

  execute({ queryParams }: { queryParams: object }) {
    return this._endOfProductionDateRepository.downloadCesedHistorical({
      queryParams
    });
  }
}

export default new DownloadCesedHistoricalCase({
  endOfProductionDateRepository: EndOfProductionDateRepository
});

export { DownloadCesedHistoricalCase };
